export default __webpack_public_path__ + "static/man1-d9a8dc0bd64a07daa249f757f853dad0.png";